import * as defaultRouter from './default';

export default defaultRouter;
